interface AccentBarProps {
  position: "top" | "bottom";
  tickOffsets?: string[];
  rightTick?: boolean;
}

export default function AccentBar({
  position,
  tickOffsets = [],
  rightTick,
}: AccentBarProps) {
  const edgeClass = position === "top" ? "top-0" : "bottom-0";

  return (
    <div className={`absolute left-0 right-0 ${edgeClass} z-10`}>
      <div className="h-px w-full bg-[#dee0e6]" />
      {tickOffsets.map((offset) => (
        <div
          key={offset}
          className={`absolute h-4 w-px bg-[#dee0e6] ${edgeClass}`}
          style={{ left: offset }}
        />
      ))}
      {rightTick && (
        <div
          className={`absolute right-0 h-4 w-px bg-[#dee0e6] ${edgeClass}`}
        />
      )}
    </div>
  );
}
